import { boot } from 'quasar/wrappers';
import axios from 'axios';



const baseURL = import.meta.env.VITE_API_URL || 'http://localhost:8000';
const api = axios.create({ baseURL })
// api.defaults.withCredentials = true;
// api.defaults.withXSRFToken = true;

const web = axios.create({ baseURL })
web.defaults.headers.common['Accept'] = 'application/json'
web.defaults.headers.common['Content-Type'] = 'application/json'
web.defaults.withCredentials = true;
web.defaults.withXSRFToken = true;

export default boot(({ app }) => {
    app.config.globalProperties.$axios = axios;
});

export { web, api };
